<p-button class="layers-btn legend-act" [rounded]="true" [text]="true" [raised]="true" (onClick)="layers.toggle($event)"><fa-icon class="layer-icon" [icon]="faLayer"></fa-icon></p-button>


<p-overlayPanel #layers class="overlay-layer" id="layer-panel">
    <label class="title-layer">{{ 'MAP.LAYERS.TITLE' | translate }}</label>
    <div class="layers-selection">
      <div class="field">
        <p-checkbox binary="true" [(ngModel)]="layer.bsn" (onChange)="onLayerChange()" 
                    [disabled]="layer.bsnDisabled || false"></p-checkbox>
        <label><b>{{ 'MAP.LAYERS.BSN' | translate }}</b></label>
      </div>
      <div class="field">
        <p-checkbox binary="true" [(ngModel)]="layer.modeles" (onChange)="onLayerChange()" 
                    [disabled]="layer.modelesDisabled || false"></p-checkbox>
        <label><b>{{ 'MAP.LAYERS.MODEL' | translate }}</b></label>
      </div>
      <div class="field">
        <p-checkbox binary="true" [(ngModel)]="layer.piezometres" (onChange)="onLayerChange()" 
                    [disabled]="layer.piezometresDisabled || false"></p-checkbox>
        <label>{{ 'MAP.LAYERS.PIEZO' | translate }}</label>
      </div>
      <div class="field">
        <p-checkbox binary="true" [(ngModel)]="layer.pluviometres" (onChange)="onLayerChange()" 
                    [disabled]="layer.pluviometresDisabled || false"></p-checkbox>
        <label>{{ 'MAP.LAYERS.RAIN' | translate }}</label>
      </div>
      <div class="field">
        <p-checkbox binary="true" [(ngModel)]="layer.hydrometrie" (onChange)="onLayerChange()" 
                    [disabled]="layer.hydrometrieDisabled || false"></p-checkbox>
        <label>{{ 'MAP.LAYERS.HYDRO' | translate }}</label>
      </div>
    </div>
    <div><i>{{ 'MAP.LAYERS.ZOOM_INFO' | translate }}</i></div>
  </p-overlayPanel>
  
  